interface CountryFieldControl {
  required: boolean;
  visible: boolean;
}

interface CountryRules {
  address_line_1: CountryFieldControl;
  address_line_2: CountryFieldControl;
  city: CountryFieldControl;
  state: CountryFieldControl;
  country: CountryFieldControl;
  postcode: CountryFieldControl;
}

interface AddressFormatField {
  visibility?: boolean;
  required?: boolean;
  order?: number;
}

type AddressFormat = Record<string, AddressFormatField>;

export function useAddressControls() {
  // const globalStore = useGlobalStore();

  const countryOverrides: Record<string, Partial<CountryRules>> = {
    ireland: {
      state: { required: false, visible: false },
      postcode: { required: false, visible: true },
    },
    "united-kingdom": {
      state: { required: false, visible: false },
    },
  };

  const hardcodedDefaults: CountryRules = {
    address_line_1: { required: true, visible: true },
    address_line_2: { required: false, visible: true },
    city: { required: true, visible: true },
    state: { required: false, visible: true },
    country: { required: true, visible: true },
    postcode: { required: true, visible: true },
  };

  // TODO: uncomment when default_address_format API is ready
  // const fieldKeyMap: Record<string, keyof CountryRules> = {
  //   address: "address_line_1",
  //   address_line_2: "address_line_2",
  //   city: "city",
  //   state: "state",
  //   country: "country",
  //   postcode: "postcode",
  // };

  // function getDefaultRules(): CountryRules {
  //   const format = (globalStore.siteSettings as Record<string, any>)?.default_address_format as
  //     | AddressFormat
  //     | undefined;
  //   if (!format) return hardcodedDefaults;
  //
  //   const rules = { ...hardcodedDefaults };
  //   for (const [configKey, rulesKey] of Object.entries(fieldKeyMap)) {
  //     const field = format[configKey];
  //     if (field) {
  //       rules[rulesKey] = {
  //         required: field.required ?? hardcodedDefaults[rulesKey].required,
  //         visible: field.visibility ?? hardcodedDefaults[rulesKey].visible,
  //       };
  //     }
  //   }
  //   return rules;
  // }

  function getFieldRules(country?: string): CountryRules {
    if (country && countryOverrides[country]) {
      return { ...hardcodedDefaults, ...countryOverrides[country] };
    }
    return hardcodedDefaults;
  }

  return {
    getFieldRules,
  };
}
